import React from 'react'

import ArticlePageLayout from '../blog/ArticlePageLayout'
import type { BlogTableOfContentsItem } from '../blog/types'
import AboutContent from './AboutContent'

const aboutTableOfContents: BlogTableOfContentsItem[] = [
  { id: 'what-is-tiny-invoice', label: 'What is TinyInvoice.app?' },
  { id: 'why-tiny-invoice', label: 'Why TinyInvoice.app?' },
  { id: 'who-runs-tiny-invoice', label: 'Built by an independent developer' },
  { id: 'privacy', label: 'Privacy' },
]

const AboutPage = () => {
  return (
    <ArticlePageLayout
      documentTitle='About us | TinyInvoice.app'
      backTo='/'
      backLabel='← Back to home'
      title='About us'
      tableOfContents={aboutTableOfContents}
    >
      <AboutContent />
    </ArticlePageLayout>
  )
}

export default AboutPage
